import PageNumbers from './PageNumbers';
export default PageNumbers;